import { render, staticRenderFns } from "./BoxSize.vue?vue&type=template&id=3c268514&"
import script from "./BoxSize.vue?vue&type=script&lang=js&"
export * from "./BoxSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports